import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import SpiderChartComponent from '@Components/Results/utils/spider-chart.component';
import { Card } from '@els/els-react--card';

import './substance-druglikeness.component.scss';

export default class SubstanceDruglikenessComponent extends React.PureComponent {
  render() {
    const {
      drugData,
      drugData: { graph },
    } = this.props;
    const listOfValues = graph ? graph.data.reduce((memo, { data }) => memo.concat(data), []) : [];
    const calcScale = listOfValues.length ? Math.ceil(Math.max(...listOfValues) / 10) : 1;

    return (
      <div className="rx-element--druglikeness-data substance-druglikeness">
        <div className="substance-druglikeness__rules">
          {drugData.tableData
            ? drugData.tableData.map((item, index) => (
                <Card
                  className="substance-druglikeness__rule-card"
                  heading={<h4 className="substance-druglikeness__rule-card-title">{item.title}</h4>}
                  headingLevel="h4"
                  key={item.title || index}>
                  <dl className="substance-druglikeness__property-list">
                    {item.children
                      ? item.children.map((child, childIndex) => (
                          <div className="substance-druglikeness__property" key={child.id || childIndex}>
                            <InnerHTML className="substance-druglikeness__property-name" tag="dt" html={child.title} />
                            <InnerHTML className="substance-druglikeness__property-value" tag="dd" html={child.value} />
                          </div>
                        ))
                      : null}
                  </dl>
                </Card>
              ))
            : null}
        </div>
        {graph && (
          <SpiderChartComponent
            className="substance-druglikeness__chart"
            categories={graph.labels}
            series={graph.data}
            tickInterval={calcScale}
          />
        )}
      </div>
    );
  }
}

SubstanceDruglikenessComponent.propTypes = {
  drugData: PropTypes.object.isRequired,
};
